import {Routes} from '@angular/router';
import {KitchenDashboardComponent} from './components/kitchen-dashboard.component';
import {KnDashboardWidgetsComponent} from './components/kn-dashboard-widgets.component';
export const kitchenDashboardRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full',
      },
      {
        path: 'main',
        component: KitchenDashboardComponent
      },
      {
        path: 'widgets',
        component: KnDashboardWidgetsComponent
      }
    ]
  }
];
